import type { IconSvgObject } from './types';

const FlagTriangleLeftIcon: IconSvgObject = [
  ["path", { d: "M19 16V2.81992C19 2.36709 18.6329 2 18.1801 2C18.0614 2 17.9442 2.02575 17.8365 2.07547L5.46185 7.78684C5.1803 7.91678 5 8.19858 5 8.50867C5 8.80979 5.17013 9.08507 5.43946 9.21973L19 16ZM19 16V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default FlagTriangleLeftIcon;
